import HeroSection from "../../components/heroSection/HeroSection";
import HowItWorks from "../../components/howItWorks/HowItWorks";
import WhyPressKit from "../../components/whyPressKit/WhyPressKit";
import { HomeContainer } from "./HomeStyles";

const Home = () => {
  return (
    <HomeContainer>
      <HeroSection />
      <WhyPressKit />
      <HowItWorks />
    </HomeContainer>
  );
};

export default Home;
